import {DigitizationTools} from "../ToolRegistry.js";
import {formatCoordinateLine} from "../FeatureVisual.js";

import {T} from "../i18n/index.js";
// Mål punkt: ét punkt i punktskyen, og resultatlabelen viser punktets
// koordinater på tre linjer (X, Y, Z). Erstatter ikke tegneværktøjet Punkt
// (kind "registration", vertex-label med navn/beskrivelse/XYZ) - dette er en
// MÅLING (kind "measurement", orange resultatlabel, ikke med i Gem
// registreringer), på linje med de øvrige Mål-værktøjer.
//
// Ingen customCapture: indsættelsen er den almindelige enkeltpunkts-
// indsættelse (maxPoints: 1 afslutter automatisk ved første venstreklik og
// genstarter værktøjet), så snap, pause/højreklik og redigering er uændret.
// Koordinatformatet er det samme som alle andre punktlabels
// (FeatureVisual.js's formatCoordinateLine(): 3 decimaler, tusindtalsskilletegn),
// så tallene kan sammenlignes direkte med fx et Punkts vertex-label.
export const PointMeasureTool = {
	id: "digitize_measure_point",
	name: T("Mål punkt"),
	category: "measurement",
	kind: "measurement",
	toolbarGroup: "measurement",
	toolbarOrder: 5,
	icon: "measure_point.svg",
	resultGeometryType: "Point",
	maxPoints: 1,
	tooltip: T("Mål et punkts koordinater (X, Y og Z) ved at vælge en position i punktskyen."),
	instructions: T("Venstreklik på punktskyen for at måle punktets koordinater."),

	// Punktets eget vertex-label ville vise de samme koordinater endnu en gang.
	suppressVertexLabels: true,

	summaryLabelFormat(raw, visual){
		if(raw.length < 1) return null;
		const [x, y, z] = raw[0];
		return [visual.name, ...formatCoordinateLine({x, y, z}).split("\n")];
	},
};

DigitizationTools.register(PointMeasureTool);
